@for (option of options; track option.id) {
  <div class="option" [ngClass]="{ invalid: passwordErrors[option.id] }">
    @if (passwordErrors[option.id]) {
      <ion-icon color="danger" name="close-outline"></ion-icon>
    } @else {
      <ion-icon color="success" name="checkmark-outline"></ion-icon>
    }
    
    <p class="small">{{ option.text }}</p>
  </div>
}
